function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from "react";
import styled from "styled-components";
import { Icon } from "../../";
const LeftContainer = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 5;
`;
const RightContainer = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 5;
`;
const TextContainer = styled.div`
  background-color: ${props => props.disabled ? props.theme.input.disabled.backgroundColor : props.theme.input.backgroundColor};
  border-radius: ${props => props.theme.input.borderRadius};
  display: block;
  position: relative;
  flex-grow: 1;
  ${props => props.error && `
  background-color: ${props.theme.input.error.backgroundColor};`}
  ${Icon} {
    color: ${props => props.disabled ? props.theme.input.disabled.placeholder.color : props.theme.input.placeholder.color};
  }
`;
export const TextField = styled.input`
  background-color: transparent;
  box-sizing: border-box;
  display: block;
  ${props => props.theme.typography.input};
  color: ${props => props.theme.input.color};
  border-color: ${props => props.theme.input.borderColor};
  border-radius: ${props => props.theme.input.borderRadius};
  border-style: solid;
  border-width: 1px;
  height: 40px;
  outline: 0;
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: ${props => props.leftIcon ? "40px" : "12px"};
  padding-right: ${props => props.rightIcon ? "40px" : "12px"};
  position: relative;
  width: 100%;
  z-index: 2;
  -webkit-appearance: none;
  &::placeholder {
    ${props => props.theme.typography.placeholder};
    ${props => props.theme.input.placeholder};
    ${props => props.disabled && props.theme.input.disabled.placeholder};
  }
  &:focus {
    ${props => props.theme.input.focus};
  }
  &:disabled {
    border-color: ${props => props.theme.input.disabled.borderColor};
    color: ${props => props.theme.input.disabled.color};
  }

  ${props => props.error && `border-color: ${props.theme.input.error.borderColor};
    border-width: 2px;
    padding-top: 6px;
    padding-bottom: 6px;
    padding-left: ${props.leftIcon ? "39px" : "11px"};
    padding-right: ${props.rightIcon ? "39px" : "11px"};
    &:focus {
      border-color: ${props.theme.input.error.borderColor};
      box-shadow: 0 0 4px 0 ${props.theme.input.error.borderColor};
    }
    `}
`;
export const Input = /*#__PURE__*/forwardRef((props, ref) => (({
  leftIcon,
  rightIcon,
  onChange,
  value,
  placeholder,
  error,
  disabled,
  style,
  placeholderStyle,
  InternalField = TextField,
  ...props
}) => {
  const handleChange = e => {
    const {
      target: {
        value
      }
    } = e;
    return onChange(value, e);
  };

  return /*#__PURE__*/React.createElement(TextContainer, {
    style: style,
    error: error,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(Placeholder, {
    visible: value,
    leftPadding: leftIcon,
    disabled: disabled,
    style: placeholderStyle
  }, placeholder), /*#__PURE__*/React.createElement(LeftContainer, null, leftIcon), /*#__PURE__*/React.createElement(InternalField, _extends({
    leftIcon: leftIcon,
    rightIcon: rightIcon,
    onChange: handleChange,
    value: value,
    error: error,
    disabled: disabled
  }, props)), /*#__PURE__*/React.createElement(RightContainer, null, rightIcon));
})({ ...props,
  ref
}));
const Placeholder = styled.div`
  align-items: center;
  display: ${props => props.visible ? "none" : "flex"};
  height: 40px;
  left: ${props => props.leftPadding ? "40px" : "12px"};
  position: absolute;
  z-index: 1;
  ${props => props.theme.typography.placeholder};
  ${props => props.theme.input.placeholder};
  ${props => props.disabled && props.theme.input.disabled.placeholder};
`;